/**
 * Copyright ©2022 Drivepoint
*/

import React, {useEffect, useState} from "react";
import {IconButton, Tooltip} from "@mui/material";
import {Upgrade} from "@mui/icons-material";
import compareVersions from "compare-versions";
import {Config, useStore} from "@bainbridge-growth/node-frontend";
import ClientStatusStore from "@services/store/ClientStatusStore";

export default function VersionUpdatedButton(props: any): any {

  const [clientStatus] = useStore<any, ClientStatusStore>(ClientStatusStore);

  const [minimumClientVersion, setMinimumClientVersion] = useState<string>();
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    setMinimumClientVersion(clientStatus?.version);
  }, [clientStatus]);

  useEffect(() => {
    if (minimumClientVersion) {
      setVisible(needsUpdate());
    } else {
      setVisible(false);
    }
  }, [minimumClientVersion]);

  function needsUpdate(): boolean {
    const version = Config.get("version");
    if (version && minimumClientVersion) {
      return compareVersions(version, minimumClientVersion) < 0;
    }
    return false;
  }

  return <Tooltip title="New version available, click to update!">
    <IconButton sx={{display: visible ? "flex" : "none"}} onClick={() => window.location.reload()}>
      <Upgrade />
    </IconButton>
  </Tooltip>;

}
